// src/components/Profile.js

import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import userImage from '../images/profile_red.png';

const Profile = ({ profileReload }) => { // Recibe profileReload como prop
    const [profileInfo, setProfileInfo] = useState({
        username: '',
        average: 0.00,
        wines: 0,
        profile: 0,
        id: 0,
        winegang: null
    });

    const loadProfileInfo = () => {
        // Cargar la informaci�n del usuario desde localStorage
        const storedUserInfo = localStorage.getItem('userLogged');
        if (storedUserInfo) {
            const userInfo = JSON.parse(storedUserInfo);
            setProfileInfo({
                username: userInfo.username,
                average: userInfo.average || 0.00,
                wines: userInfo.wines || 0,
                id: userInfo.id || 0,
                profile: userInfo.profile || 'default',
                winegang: userInfo.winegang || null
            });
        }
    };

    // Recargar profileInfo cada vez que profileReload cambie
    useEffect(() => {
        loadProfileInfo();
    }, [profileReload]); // Se ejecuta cuando profileReload cambia

    const getProfileImageUrl = () => {
        return userImage;  // Imagen por defecto si profile es vac�o
    };

    if (!profileInfo) return null; // Retorna null si no hay datos en localStorage

    return (
        <div className="user-info">
            <Link to={`/edit-data`}>
                <div className="user-details">
                    <img src={getProfileImageUrl()} alt="Imagen de usuario" className="user-image" />
                    <div className="user-text">
                        <div className="user-name">
                            {profileInfo.username}
                        </div>
                        <div className="user-group">
                            {profileInfo.winegang
                            ? `${typeof profileInfo.winegang === 'string' ? profileInfo.winegang : (profileInfo.winegang.name ?? '')}`
                            : ``
                        }
                        </div>
                    </div>
                </div>
            </Link>
        </div>
    );
};

export default Profile;
